module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/GS_logo-1c9400281e2fd5e43c8f2405c6736397.svg";